var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.matched[1].meta.title))]),(_vm.activeMenu)?_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.activeMenu.label))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }